/**
 * 3단계 판단법(MIRAS) 엑셀 서식(public/fms/위험성평가_3등급_MIRAS.xlsx) 레이아웃 정의
 *
 * 서식 생성(scripts/generate-risk-3grade-template.js), 목록 엑셀 내보내기(List.js),
 * 엑셀 업로드(ExcelUpload.vue)가 모두 이 파일을 기준으로 셀 위치를 계산한다.
 * 행 구성을 바꾸면 서식을 다시 생성해야 한다.
 */

// 위험성평가표 컬럼 (1-based 컬럼 번호 = 배열 순서)
export const RISK_COLUMNS = [
  { key: "no", title: "No.", width: 6, align: "center", readonly: true },
  { key: "공종분류", title: "①공종분류", width: 16 },
  { key: "단위작업", title: "②단위작업", width: 16 },
  { key: "위험요인", title: "③위험요인", width: 42 },
  { key: "재해형태", title: "재해형태", width: 16, align: "center" },
  { key: "가능성", title: "가능성\n(1~5)", width: 9, align: "center" },
  { key: "중대성", title: "중대성\n(1~4)", width: 9, align: "center" },
  { key: "위험점수", title: "위험점수\n(자동계산)", width: 10, align: "center", readonly: true },
  { key: "위험도등급", title: "④위험도 등급\n(상/중/하)", width: 12, align: "center", readonly: true },
  { key: "위험방지대책", title: "⑤위험방지대책", width: 42 },
  { key: "담당자", title: "⑥개선조치\n담당자", width: 14, align: "center" },
  { key: "조치예정일", title: "조치예정일", width: 14, align: "center" },
  { key: "이행확인_근로자대표", title: "➉이행확인\n근로자대표", width: 12, align: "center" },
  { key: "이행확인_관리감독자", title: "➉이행확인\n관리감독자", width: 12, align: "center" },
];

// ➆ 위험성 결정, 감소대책 수립 및 실행계획 확인 컬럼
export const MANAGER_COLUMNS = [
  { key: "소속명", title: "소속명" },
  { key: "직급", title: "직급" },
  { key: "직책", title: "직책" },
  { key: "이름", title: "이름" },
];

// 개선현황(사진) 컬럼. 사용자가 붙여넣은 이미지는 위치(컬럼)로 조치 전/후를 구분하므로
// 두 칸을 충분히 떨어뜨려 배치한다.
export const PHOTO_COLUMNS = [
  { key: "no", title: "No.", col: 1 },
  { key: "before", title: "조치 전 사진", col: 2 },
  { key: "after", title: "조치 후 사진", col: 8 },
];

export const LAYOUT = {
  sheetName: "위험성평가",
  lastColumn: RISK_COLUMNS.length,

  // 기본정보 (label / value 셀 위치)
  info: {
    회사명: { row: 1, labelCol: 1, valueCol: 2, label: "회사명" },
    공정명: { row: 1, labelCol: 5, valueCol: 6, label: "공정명" },
    작성자: { row: 2, labelCol: 1, valueCol: 2, label: "작성자" },
    작업내용: { row: 2, labelCol: 5, valueCol: 6, label: "작업내용" },
    작성일: { row: 3, labelCol: 1, valueCol: 2, label: "작성일" },
  },

  // ❶ 위험성평가표
  risk: {
    titleRow: 5,
    headerRow: 6,
    dataStartRow: 7,
    templateRows: 10,
  },

  // ❷ ➆ 위험성 결정, 감소대책 수립 및 실행계획 확인
  manager: {
    titleRow: 18,
    headerRow: 19,
    dataStartRow: 20,
    templateRows: 4,
  },

  // ❸ 개선현황
  photo: {
    titleRow: 25,
    headerRow: 26,
    dataStartRow: 27,
    templateRows: 4,
    // 이 컬럼 번호 미만에 붙은 이미지는 '조치 전', 이상은 '조치 후' 로 판단한다
    beforeAfterSplitCol: 8,
  },
};
